<div class="container-fluid">
	<div class="row">

		<div class="col-lg-6 d-flex align-items-center" style="height: 100vh;">
			<div class="login-form">
				<h3 *ngIf="!registrazioneOk" class="py-4">{{ "register.titolo" | translate }}</h3>
				<form [formGroup]="fg">
					<div class="row">
						<ng-container *ngIf="!registrazioneOk">
							<div class="form-group col-12 col-lg-6">
								<itm-textbox [forceValidation]="forceValidation" formControlName="nome"
									label="{{ 'register.nome' | translate }}">
									{{ 'register.nome_mancante' | translate }}</itm-textbox>
							</div>
							<div class="form-group col-12 col-lg-6">
								<itm-textbox [forceValidation]="forceValidation" formControlName="cognome"
									label="{{ 'register.cognome' | translate }}">
									{{ 'register.cognome_mancante' | translate }}</itm-textbox>
							</div>
							<div class="form-group col-12 col-lg-8">
								<itm-textbox [forceValidation]="forceValidation" formControlName="email"
									label="{{ 'register.email' | translate }}">
									{{ 'register.email_mancante_o_non_valida' | translate }}</itm-textbox>
							</div>
							<div class="form-group col-12 col-lg-4">
								<itm-combobox [forceValidation]="forceValidation" formControlName="lingua"
									label="{{ 'register.lingua' | translate }}" [list]="linguaList">
									{{ 'register.lingua_mancante_o_non_valida' | translate }}</itm-combobox>
							</div>
							<div class="form-group col-12">
								<itm-textbox [forceValidation]="forceValidation" formControlName="password" type="password"
									label="{{ 'register.password' | translate }}">
									{{ 'register.password_mancante_o_non_valida' | translate }}
								</itm-textbox>
								<small class="d-block">{{'common.regole_password' | translate}}</small>
							</div>
							<div class="form-group col-12">
								<itm-textbox [forceValidation]="forceValidation" formControlName="conferma_password" type="password"
									label="{{ 'register.conferma_password' | translate }}">
									{{ 'register.password_mancante_o_non_valida' | translate }}
								</itm-textbox>
							</div>
							<div class="form-group col-12">
								<div class="form-check mx-0 px-0 mt-2">
									<itm-checkbox [cssClassLabel]="'ml-0'" formControlName="condizioni" label="{{ 'register.accetto_le_condizioni_di_utilizzo_del_software' | translate }}">
									</itm-checkbox><itm-button (myClick)="condizioni()" [cssClass]="'btn-sm btn-link p-2 m-0 mx-2'" [label]="'common.visualizza' | translate" ></itm-button>
									<small *ngIf="fg?.get('condizioni').invalid && forceValidation" class="d-block text-danger">
										{{ 'register.devi_accettare_le_condizioni' | translate }}
									</small>									
								</div>
							</div>
							<div class="form-group col-12">
								<itm-button (myClick)="onSubmit()" label="{{ 'register.crea_account' | translate }}"
									cssClass="btn-primary btn-block">
								</itm-button>
								<small *ngIf="forceValidation && fg.invalid" class="text-danger d-block">
									{{ 'common.verifica_i_campi_evidenziati' | translate }}
								</small>
							</div>
							<div class="form-group text-center">
								<span>{{ 'register.gia_registrato' | translate }}?</span>
								<a class="pl-2 py-2 btn-link" (click)="login()">{{ 'register.accedi' | translate }}</a>
							</div>
						</ng-container>
						<div *ngIf="registrazioneOk" class="alert alert-success text-center">
							{{ "register.registrazione_ok" | translate }}
						</div>
					</div>

				</form>
			</div>

		</div>
		<div class="col login-right d-lg-flex d-none">
			<h3>{{ 'login.entra_nella_nostra_community' | translate }}</h3>
		</div>
	</div>
</div>